import { useTheme } from '@shopify/restyle';
import { Pressable } from 'react-native';
import type { Theme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

export function InviteCloseButton({ isLargeUI, onClose }: { isLargeUI: boolean; onClose: () => void }) {
  const theme = useTheme<Theme>();
  if (isLargeUI) return null;
  return (
    <Pressable
      onPress={onClose}
      style={{ marginLeft: theme.spacing['spacing.general.x4'], marginTop: theme.spacing['spacing.general.x2'] }}
    >
      <IconX strokeWidth={ICON_STROKE_WIDTH} />
    </Pressable>
  );
}
